import TreeTrunk from './TreeTrunk';

interface TrunkContinuationsProps {
  trunkContinuations: boolean[];
  trunkLeftOf: (level: number) => number;
}

const TrunkContinuations = ({ trunkContinuations, trunkLeftOf }: TrunkContinuationsProps) => (
  <>
    {trunkContinuations.map((hasTrunk, i) => {
      if (!hasTrunk) {
        return null;
      }

      const ancestorDepth = i + 1;
      return <TreeTrunk key={i} left={trunkLeftOf(ancestorDepth)} />;
    })}
  </>
);

export default TrunkContinuations;
